import * as React from "react";
const StudentIcon = (props) => (
  <svg
    fill="none"
    height={25}
    width={24}
    viewBox="0 0 24 25"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 12.39a5 5 0 1 1 0-10 5 5 0 0 1 0 10ZM3.41 22.39c0-3.87 3.85-7 8.59-7s8.59 3.13 8.59 7"
    />
  </svg>
);
export default StudentIcon;
